<template>
  <v-container
    class="ma-0 pa-0"
    fluid
    fill-height
  >

    <!-- 1 -->
    <template v-if="layout === '1'">
      <v-layout
        align-space-around
        justify-center
        row
        wrap
      >
        <v-flex xs12>
          <module-container initialModule="CHAT" />
        </v-flex>
      </v-layout>
    </template>

    <!-- 1-1 -->
    <Split
      v-if="layout === '1-1'"
      :gutterSize="10"
      @onDragEnd="onHorizontalDragEnd"
      style="height: calc(100vh - 64px);"
    >
      <SplitArea
        :size="70"
        :minSize="350"
      >
        <module-container
          initialModule="MAP"
          position="LEFT"
        />
      </SplitArea>
      <SplitArea
        :size="30"
        :minSize="350"
      >
        <module-container
          initialModule="CHAT"
          position="RIGHT"
        />
      </SplitArea>
    </Split>

    <!-- 2-1 -->
    <Split
      v-if="layout === '2-1'"
      :gutterSize="10"
      @onDragEnd="onHorizontalDragEnd"
      style="height: calc(100vh - 64px);"
    >
      <SplitArea
        :size="70"
        :minSize="350"
      >
        <Split
          :gutterSize="10"
          @onDragEnd="onVerticalLeftDragEnd"
          direction="vertical"
          style="height: calc(100vh - 64px);"
        >
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="MAP"
              position="TOP_LEFT"
            />
          </SplitArea>
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="CUSTOMERS"
              position="BOTTOM_LEFT"
            />
          </SplitArea>
        </Split>
      </SplitArea>
      <SplitArea
        :size="30"
        :minSize="350"
      >
        <module-container
          initialModule="CHAT"
          position="RIGHT"
        />
      </SplitArea>
    </Split>

    <!-- 1-2 -->
    <Split
      v-if="layout === '1-2'"
      :gutterSize="10"
      @onDragEnd="onHorizontalDragEnd"
      style="height: calc(100vh - 64px);"
    >
      <SplitArea
        :size="40"
        :minSize="350"
      >
        <module-container
          initialModule="CHAT"
          position="LEFT"
        />
      </SplitArea>
      <SplitArea
        :size="60"
        :minSize="350"
      >
        <Split
          :gutterSize="10"
          @onDragEnd="onVerticalRightDragEnd"
          direction="vertical"
          style="height: calc(100vh - 64px);"
        >
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="MAP"
              position="TOP_RIGHT"
            />
          </SplitArea>
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="CUSTOMERS"
              position="BOTTOM_RIGHT"
            />
          </SplitArea>
        </Split>
      </SplitArea>
    </Split>

    <!-- 2-2 -->
    <Split
      v-if="layout === '2-2'"
      :gutterSize="10"
      @onDragEnd="onHorizontalDragEnd"
      style="height: calc(100vh - 64px);"
    >
      <SplitArea
        :size="50"
        :minSize="350"
      >
        <Split
          :gutterSize="10"
          @onDragEnd="onVerticalRightDragEnd"
          direction="vertical"
          style="height: calc(100vh - 64px);"
        >
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="MAP"
              position="TOP_RIGHT"
            />
          </SplitArea>
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="CHAT"
              position="BOTTOM_RIGHT"
            />
          </SplitArea>
        </Split>
      </SplitArea>
      <SplitArea
        :size="50"
        :minSize="350"
      >
        <Split
          :gutterSize="10"
          @onDragEnd="onVerticalLeftDragEnd"
          direction="vertical"
          style="height: calc(100vh - 64px);"
        >
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="CUSTOMERS"
              position="TOP_LEFT"
            />
          </SplitArea>
          <SplitArea
            :size="50"
            :minSize="200"
          >
            <module-container
              initialModule="CHAT"
              position="BOTTOM_LEFT"
            />
          </SplitArea>
        </Split>
      </SplitArea>
    </Split>

    <!-- 1-2-1 -->
    <Split
      v-if="layout === '1-2-1'"
      :gutterSize="10"
      @onDragEnd="onHorizontalDragEnd"
      style="height: calc(100vh - 64px);"
    >
      <SplitArea
        :size="25"
        :minSize="350"
      >
        <module-container
          initialModule="CUSTOMERS"
          position="LEFT"
        />
      </SplitArea>
      <SplitArea
        :size="75"
        :minSize="350"
      >
        <Split
          :gutterSize="10"
          @onDragEnd="onHorizontalDragEnd"
          style="height: calc(100vh - 64px);"
        >
          <SplitArea
            :size="67"
            :minSize="350"
          >
            <Split
              :gutterSize="10"
              @onDragEnd="onVerticalRightDragEnd"
              direction="vertical"
              style="height: calc(100vh - 64px);"
            >
              <SplitArea
                :size="50"
                :minSize="200"
              >
                <module-container
                  initialModule="MAP"
                  position="TOP_RIGHT"
                />
              </SplitArea>
              <SplitArea
                :size="50"
                :minSize="200"
              >
                <module-container
                  initialModule="CONTACTS"
                  position="BOTTOM_RIGHT"
                />
              </SplitArea>
            </Split>
          </SplitArea>
          <SplitArea
            :size="33"
            :minSize="350"
          >
            <module-container
              initialModule="CHAT"
              position="RIGHT"
            />
          </SplitArea>

        </Split>
      </SplitArea>
    </Split>

    <event-partners-dialog v-if="eventPartnersDialog" />
    <event-translators-dialog v-if="eventTranslatorsDialog" />

  </v-container>
</template>

<script>
import ModuleContainer from "./ModuleContainer";
import EventPartnersDialog from "@/components/events/EventPartnersDialog";
import EventTranslatorsDialog from "@/components/events/EventTranslatorsDialog";
import { getApi } from "@/api";
import { setTimeout } from 'timers';

let getOnDragEndHandler = position => {
  return size => {
    console.log("position size", position, size);
    this.$bus.$emit("event-module-resized", { position });
  };
};

export default {
  data() {
    return {
      fetchingManager: false
    };
  },

  computed: {
    layout() {
      return this.$store.getters["events/eventPageLayout"];
    },
    eventId() {
      return this.$route.params.id;
    },
    event() {
      return this.$store.getters["entity"]("events", this.eventId);
    },
    eventPartnersDialog: {
      get() {
        return this.$store.getters["events/eventPartnersDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_PARTNERS_DIALOG", isActive);
      }
    },
    eventTranslatorsDialog: {
      get() {
        return this.$store.getters["events/eventTranslatorsDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_TRANSLATORS_DIALOG", isActive);
      }
    }
  },

  methods: {
    onVerticalLeftDragEnd(size) {
      this.$store.commit("events/SET_EVENT_PAGE_LAYOUT_SIZE", {
        position: "topLeft",
        size: size[0]
      });
    },
    onVerticalRightDragEnd(size) {
      this.$store.commit("events/SET_EVENT_PAGE_LAYOUT_SIZE", {
        position: "topRight",
        size: size[0]
      });
    },
    onHorizontalDragEnd(size) {
      this.$bus.$emit("map-invalidate-size");
      this.$store.commit("events/SET_EVENT_PAGE_LAYOUT_SIZE", {
        position: "left",
        size: size[0]
      });
    },
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/events/" + this.eventId,
          entityType: "events",
          schema: "eventListSchema"
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    clearAllEventData() {
      console.log('Event clearAllEventData - clearing cached data');
      
      // Clear chat messages
      this.$store.commit("chats/CLEAR_CHAT_MESSAGES");
      
      // Clear event-specific data from store
      this.$store.commit("events/SET_EVENT_IDS_TO_SHOW", []);
      this.$store.commit("events/SET_SHOW_ALL_EVENTS", false);
      
      console.log('Event clearAllEventData - chat messages and event data cleared');
    },
    fetchManager() {
      this.fetchingManager = true;
      getApi()
        .then(api => {
          let params = {
            q: JSON.stringify({
              event: this.eventId,
              role: this.eventManagerRoleId
            }),
            limit: 1,
            sort: "-startDate"
          };
          return api.get("duties", { params });
        })
        .then(({ data }) => {
          if (Array.isArray(data.results) && data.results.length) {
            let managerId = data.results[0].user;
            this.$store.commit('events/SET_EVENT_CURRENT_MANAGER', {
              eventId: this.eventId,
              managerId
            })
          }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetchingManager = false;
        });
    }
  },

  components: {
    ModuleContainer,
    EventPartnersDialog,
    EventTranslatorsDialog
  },

  mounted() {
    this.fetch();
    this.fetchManager();
    setTimeout(() => {
      this.$bus.$emit("event-module-resized");
      this.$bus.$emit("map-invalidate-size");
    },3000)
  },

  watch: {
    // Watch for route changes to refetch data when navigating to different events
    '$route.params.id': {
      handler(newEventId, oldEventId) {
        console.log('Event watcher - route changed from:', oldEventId, 'to:', newEventId);
        if (newEventId && newEventId !== oldEventId) {
          // Clear chat messages
          this.clearAllEventData();
          
          // Set the current event ID in eventIdsToShow
          this.$store.commit("events/SET_EVENT_IDS_TO_SHOW", [newEventId]);
          
          // Refetch event data
          this.fetch();
          this.fetchManager();
          
          // Emit global refetch event to notify all components
          this.$bus.$emit('refetch-all-data');
        }
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.split {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.content {
  border: 1px solid #333;
  box-shadow: inset 0 1px 2px #e4e4e4;
  background-color: #fff;
}

.gutter {
  
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: 50%;
}

.gutter.gutter-horizontal {
  cursor: col-resize;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==");
}

.gutter.gutter-vertical {
  cursor: row-resize;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=");
}

.split.split-horizontal,
.gutter.gutter-horizontal {
  height: 100%;
  float: left;
}
</style>

<style>

.gutter {
  background-color: #dedede;
}

</style>


// WEBPACK FOOTER //
// src/components/events/Event.vue